import Loading from './loading'
import Scroll from './scroll'
import Story from './story'
import Accordion from './accordion'

Loading();
Scroll();
Story();
Accordion();